import './switch-button-2.styles.scss';

/**
 * 
 * @param {*} props
 * @param {boolean} [props.active]
 * @param {Function} [props.onChange]
 * @param {boolean} [props.disabled]
 * @param {string} [props.label]
 * @param {string} [props.className]
 * @returns 
 */
const SwitchButton2 = ({ active, onChange = () => {}, disabled, label, className }) => {
  return (
    <div className='d-flex gap-4 align-items-center'>
      <div 
        className={`switch-button-2 pointer ${active ? 'active' : ''} ${disabled ? 'disabled' : ''} ${className}`}
        onClick={() => {
          if (disabled) return;
          onChange(!active);
        }}
      >
        <div className={`circle`} />
      </div>
      {label && (
        <span 
          className='text-muted pointer' 
          onClick={() => {
            if (disabled) return;
            onChange(!active);
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}

export default SwitchButton2;
